import { render, staticRenderFns } from "./addOriginal.vue?vue&type=template&id=a84dbf58&scoped=true"
import script from "./addOriginal.vue?vue&type=script&lang=js"
export * from "./addOriginal.vue?vue&type=script&lang=js"
import style0 from "./addOriginal.vue?vue&type=style&index=0&id=a84dbf58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84dbf58",
  null
  
)

export default component.exports